import ListStarted from './ListStarted/ListStarted';
import Button from '../Button/Button';
import Divider from '../../components/Divider/Divider';
import { SectionsProps } from '../../types/types';
const Started = ({ openModal }: SectionsProps) => {
  return (
    <section className='started'>
      <Divider />
      <div className='started__container'>
        <h1 className='started__title title color'>
          How to
          <span className='title title'> Get Started</span>
        </h1>
        <div className='started__inner'>
          <ListStarted className='started-list' />
        </div>
        <Button className='started__button' onClick={openModal}>
          Talk to sales
        </Button>
      </div>
    </section>
  );
};
export default Started;
